import { ResultModel } from "../../search/models/result";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";
import { prop} from "../../decorators/property";
@backboneCollectionProperties({
    model: ResultModel
})
export class ResultsCollection extends Backbone.Collection<ResultModel> {

    constructor(options?) {
        super(options);
    }

    public requestMoreResults(): void {
        const first = this.first(); // as far as I can't tell you can't trigger events on collections, only on models within the collection
        if (first) {
            first.requestingLoad = !first.requestingLoad;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/collections/results.ts